export default __webpack_public_path__ + "static/media/user-bg.c514725a.png";